import React from "react"
import RadioQuestion from "./RadioQuestion"
import TextQuestion from "./TextQuestion"
import { QUESTION_TYPES } from "../../../consts/modules/survey.consts"

export default function QuestionRenderer({
  question,
  value,
  updateAnswer,
  error,
  onClearError,
}) {
  switch (question.typeName) {
    case QUESTION_TYPES.RADIO:
      return (
        <RadioQuestion
          question={question}
          value={value}
          updateAnswer={updateAnswer}
          error={error}
          onClearError={onClearError}
        />
      )

    case QUESTION_TYPES.TEXT:
      return (
        <TextQuestion
          question={question}
          value={value}
          updateAnswer={updateAnswer}
          error={error}
          onClearError={onClearError}
        />
      )

    default:
      return null
  }
}
